/** @jsxImportSource @emotion/react */

import type { ComponentPropsWithRef, ElementType } from "react";
import { forwardRef } from "react";
import { Spinner } from "../../Spinner";
import { iconButtonCSS } from "./IconButton.css";
import type { IconButtonProps } from "./IconButton.types";

type IconButtonComponent = <E extends ElementType = "button">(
  props: IconButtonProps<E> & {
    ref?: ComponentPropsWithRef<E>["ref"];
  },
) => JSX.Element | null;

const IconButton: IconButtonComponent = forwardRef(
  <E extends ElementType>(props: IconButtonProps<E>, ref: ComponentPropsWithRef<E>["ref"]) => {
    const Element = props.as ?? "button";
    const { isLoading, isDisabled, icon } = props;

    return (
      <Element
        ref={ref}
        data-imweb-loading={isLoading}
        disabled={isLoading || isDisabled}
        css={[iconButtonCSS(props), props.sx]}
        {...props}
        {...props.native}
      >
        {isLoading ? <Spinner /> : icon}
      </Element>
    );
  },
);

const IconButtonNameSpace = Object.assign(IconButton, { displayName: "Clay.IconButton" });

export { IconButtonNameSpace as IconButton };
